import { DOM } from './matchMedia/browser';
import Header from '@mands/mns-core-ui-header/dist/templates/header/bundle';
import Footer from '@mands/mns-core-ui-footer/dist/templates/footer/bundle';
import { ViewPort } from './matchMedia';
import '@mands/mns-fe-pattern-library/lib/mns-fe-utilities/lazy-load';
import previewBanner from '@mands/mns-fe-pattern-library/lib/mns-fe-utilities/preview-banner';
import * as DotComPlusMenu from '@mands/dot-com-plus-menu';
import ukConstants from '../../config/constants/uk/constants';
import ukReleaseConstants from '../../config/constants/uk/releaseConstants';
import roiConstants from '../../config/constants/roi/constants';
import roiReleaseConstants from '../../config/constants/roi/releaseConstants';

/* istanbul ignore file */
export const constants = window.location.href.indexOf('/ie/') > 0 ? roiConstants : ukConstants;
export const releaseConfig = window.location.href.indexOf('/ie/') > 0 ? roiReleaseConstants : ukReleaseConstants;

DOM.ready(() => {
    if (document.querySelector('body > .header')) {
        new Header.Top();
        new Header.Navigation();
        new Footer.Top();

        try {
            DotComPlusMenu.render('#dcplus', constants.dotComPlusUrls);
        } catch (e) {
            throw `Could not load DotComPlusMenu: ${e}`;
        }
    }

    previewBanner.init();
});

document.addEventListener('scroll', () => {
    const loadModeDefault = 2;
    const loadModePreferred = 1;
    if (window.lazySizesConfig && window.lazySizesConfig.loadMode === loadModeDefault) {
        window.lazySizesConfig.loadMode = loadModePreferred;
    }
});

window.getChannelId = () => {
    const viewport = ViewPort.getCurrent();

    const desktop = -1;
    const mobile = -6;

    return viewport === ViewPort.xl ? desktop : mobile;
};

export function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

export function addClass(el, className) {
    if (el.classList) {
        el.classList.add(className);
    } else if (!hasClass(el, className)) {
        el.className += ' ' + className;
    }
}

export function removeClass(el, className) {
    if (el.classList) {
        el.classList.remove(className);
    } else if (hasClass(el, className)) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ');
    }
}

export function getIsLoyaltyCookie() {
    if (window.location.href.indexOf('/ie/') > 0) {
        return 'IS_LOYALTY_USER_COOKIE_IE';
    }
    return 'IS_LOYALTY_USER_COOKIE';
}